import styles from "../../styles/profile/Greetings.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Greetings() {
  const msg = [
    "정확한 판단, 신속한 대응, 신뢰할 수 있는 손해사정",
    "모든 부분에서 <strong>으뜸손해사정</strong>이 함께합니다.",
    "안녕하십니까.",
    "\n",
    "으뜸손해사정을 찾아주셔서 진심으로 감사드립니다.",
    "\n",
    "예기치 못한 사고는 개인과 기업 모두에게 큰 부담과 혼란을 안겨줍니다. 특히 보험사고가 발생한 이후에는 손해의 원인과 범위를 정확히 확인하고, 적정한 보상이 이루어질 수 있도록 체계적인 대응이 필요합니다.",
    "\n",
    "으뜸손해사정은 이러한 과정에서 고객의 든든한 조력자가 되고자 합니다. 전문적인 지식과 풍부한 현장 경험을 바탕으로, 공정하고 신뢰할 수 있는 손해사정 서비스를 제공하겠습니다. 언제나 고객의 입장에서 생각하고, 결과로 신뢰받는 손해사정법인이 되겠습니다.",
    "\n",
    "감사합니다.",
    "\n",
    "으뜸손해사정사 임직원 일동",
  ];

  return (
    <div className={cx("greetingsWrap", "wrapper")}>
      <div className={cx("title")}>
        <h4>인사말</h4>
      </div>

      <div className={cx("contentWrap", "reveal")}>
        <figure className={cx("imgWrap")}>
          <img src="/img/performance.jpg" alt="img" />
        </figure>
        <article className={cx("textWrap")}>
          {msg.map((text, index) =>
            text === "\n" ? (
              <br key={index} />
            ) : (
              <p key={index} dangerouslySetInnerHTML={{ __html: text }}></p>
            )
          )}
        </article>
      </div>
    </div>
  );
}
